import Vue from 'vue'
import Vuex from 'vuex'


//Admin:
import accounts from './modules/admin/LinkDSG/dsgAccounts'
import sysUsers from './modules/admin/LinkDSG/dsgUsers'
import sysItems from './modules/admin/LinkDSG/dsgItems'
import orders from './modules/admin/LinkDSG/dsgOrders'
import sysEquipment from './modules/admin/LinkDSG/dsgEquipment'
// import sysEquipment from './modules/admin/systemEquipment'

//Global:
import user from './modules/common/LinkDsg/auth'

//Customer:
import customer from './modules/common/LinkDsg/customer'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isLoading: false
    },
    mutations: {
        setStatus(state, stat) {
            state.isLoading = stat;
        }
    },
    actions: {
        updateStat({ commit }, stat) {
            commit('setStatus', stat)
        }
    },
    getters: {
        isLoading: state => state.isLoading
    },
    modules: {
        accounts,
        orders,
        sysUsers,
        sysItems,
        sysEquipment,
        user,
        customer
    }
})





// WEBPACK FOOTER //
// ./src/store/store.js